"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillers = getFulfillers;

var FulfillerIdentity = require('cimpress-fulfiller-identity');

function getFulfillers(token, options) {
  var fulfillerIdentity = new FulfillerIdentity('Bearer ' + token, {
    timeout: 8000
  });
  return fulfillerIdentity.getFulfillers(options);
}